module.exports = __webpack_public_path__ + "assets/images/backArrow.6dc0e0d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Planning/assets/backArrow.png
// module id = 1249
// module chunks = 0